"use strict";

import React, {useState, useEffect} from 'react';
import SwiperCore, {Navigation, Lazy, Pagination} from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import {Magnifier, MOUSE_ACTIVATION, TOUCH_ACTIVATION} from "react-image-magnifiers";
import mqListener from "../../mqListener";
import ProductGalleryMediumUp from "./ProductGalleryMediumUp";
import ProductGalleryFullScreen from "./ProductGalleryFullScreen";
import ProductGallerySlide from "./ProductGallerySlide";
import ProductGalleryToolbar from "./ProductGalleryToolbar";

SwiperCore.use([Navigation, Lazy, Pagination]);

const ProductGallery = ({slides=[],}) => {
    const [mQuery, setMQuery] = useState(null);
    const [isMediumUp, setIsMediumUp] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const largeImgPath = '/assets/img/products/large/';
    const zoomImgPath = '/assets/img/products/zoom/';
    const loopedSlides = !!slides.length && slides.length >= 1 ? 1 : 0;
    const lazyLoading = {
        preLoaderClassName: 'loading-lazy-preloader',
        preLoaderElementClassName: 'loading-lazy-preloader loading loading--w-flip loading--center-flex loading--cover',
        imgPlaceholderSrc: '/assets/img/style/product-placeholder--transparent.png',
    };
    useEffect(()=>{
        setMQuery( ()=>{return mqListener('(min-width: 640px)', handleMQChange)});
        return ()=>{
            mQuery.removeListener(handleMQChange);
        };
    }, []);

    useEffect(()=>{
        //
    }, [currentIndex]);

    function handleMQChange(mq){
        setIsMediumUp(()=>{return mq.matches});
    }

    function handleSlideChange(gallery){
        //gallery.allowTouchMove = true;
        setCurrentIndex(gallery.realIndex);
    }

    function toggleIsFullScreen(e){
        e.preventDefault();
        setIsFullScreen(()=>{return !isFullScreen});
    }

    function onFullScreenClick(e){
        toggleIsFullScreen(e);
    }

    if(!!slides && slides.length){
        return (
            <React.Fragment>
                {!isMediumUp && !!slides && !!slides.length &&
                <React.Fragment>
                    {slides.length === 1 &&
                            <React.Fragment>
                                <ul className="product-images__list slides">
                                    <li className="product-images__list-item slide slide--active">
                                        <ProductGallerySlide slide={slides[0]} slideAltText={`Product Image`} />
                                    </li>
                                </ul>
                                <ProductGalleryToolbar className="product-detail__slides__toolbar__container--medium-up"
                                                       style={{borderBottom: '1px solid #bbbbbb',}}
                                                       index={currentIndex}
                                                       slidesLength={slides.length}
                                                       onFullScreenClick={onFullScreenClick} />
                            </React.Fragment>
                        ||
                        <React.Fragment>
                            <Swiper
                                className={'product-detail__slides__container'}
                                tag="div"
                                wrapperTag="ul"
                                navigation
                                slidesPerView={1}
                                grabCursor={false}
                                simulateTouch={false}
                                loop={true}
                                loopedSlides={loopedSlides}
                                onSwiper={(swiper)=>{
                                    swiper.slideToLoop(currentIndex);
                                    swiper.on('slideChange', function () {
                                        handleSlideChange(swiper);
                                    });
                                }} >
                                {slides.map((slide, index)=>
                                    <SwiperSlide tag="li" style={{background: '#eeeeee',}} key={`slideKey0-${index}`}>
                                        <ProductGallerySlide slide={slide}
                                                             slideAltText={`Product Image`} />
                                    </SwiperSlide>
                                )}
                            </Swiper>
                            <ProductGalleryToolbar className="product-detail__slides__toolbar__container--medium-up"
                                                   index={currentIndex}
                                                   slidesLength={slides.length}
                                                   onFullScreenClick={onFullScreenClick} />
                        </React.Fragment>
                    }
                    </React.Fragment>
                }
                <ProductGalleryMediumUp
                    slides={slides}
                    currentIndex={currentIndex}
                    largeImgPath={largeImgPath}
                    zoomImgPath={zoomImgPath}
                    isMediumUp={isMediumUp}
                    isFullScreen={isFullScreen}
                    onSlideChange={handleSlideChange}
                    onFullScreenClick={toggleIsFullScreen}
                    lazyLoading={lazyLoading} />
                <ProductGalleryFullScreen
                    slides={slides}
                    currentIndex={currentIndex}
                    largeImgPath={largeImgPath}
                    zoomImgPath={zoomImgPath}
                    isMediumUp={isMediumUp}
                    onSlideChange={handleSlideChange}
                    showFullScreen={isFullScreen}
                    onFullScreenClick={toggleIsFullScreen}
                    lazyLoading={lazyLoading} />
            </React.Fragment>
        );
    }
    else
        return null;
};

export default ProductGallery;
